import { render } from "./GenericProfileField.vue?vue&type=template&id=3c1791b0"
import script from "./GenericProfileField.vue?vue&type=script&lang=js"
export * from "./GenericProfileField.vue?vue&type=script&lang=js"
script.render = render

export default script